import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";

/**
 * Renders a Leaflet.heat heatmap layer over the given points.
 *
 * @param {Array<{lat:number, lon:number, weight:number}>} points
 * @param {Object} options - leaflet.heat options (radius, blur, max, gradient, ...)
 */
export default function HeatmapLayer({ points = [], options = {} }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !points.length) return undefined;
    const data = points.map((p) => [p.lat, p.lon, p.weight ?? 1]);
    const layer = L.heatLayer(data, {
      radius: 28,
      blur: 24,
      maxZoom: 11,
      minOpacity: 0.35,
      max: 1.0,
      gradient: {
        0.0: "#1E293B",
        0.2: "#5B21B6",
        0.4: "#DC2626",
        0.6: "#EA580C",
        0.8: "#F59E0B",
        1.0: "#FEF3C7",
      },
      ...options,
    }).addTo(map);
    return () => {
      map.removeLayer(layer);
    };
  }, [map, points, options]);

  return null;
}
